import {
  initFrontendLogger,
} from "~/composables/useFrontendLogger";

export default defineNuxtPlugin(() => {
  initFrontendLogger();
});
